const singleVideo = jQuery('.js-single-video-asset');
const singleVideoOverlay = jQuery('.single-video__overlay');

singleVideo.on('click', function() {
    if (this.paused) {
        this.play(); 
        singleVideoOverlay.addClass('playing');
    } else {
        this.pause(); 
        singleVideoOverlay.removeClass('playing');
    }
});

singleVideo.on('ended', function() {
    singleVideoOverlay.removeClass('playing');
});